export const baseSports = [
  {
    id: '420',
    sport: 'baseball',
    name: 'MLB',
    link: '/baseball/mlb',
    disabled: false,
    leagues: ['mlb', 'wbc'],
  },
  {
    id: '4',
    sport: 'fighting',
    name: 'FIGHTS',
    link: '/fighting/ufc',
    disabled: false,
    leagues: ['ufc', 'dwcs', 'boxing'],
  },
  {
    id: '55',
    sport: 'soccer',
    name: 'SOCCER',
    link: '/soccer/featured-soccer',
    disabled: false,
    leagues: ['all'],
  },
  {
    id: '340041',
    sport: 'basketball',
    name: 'WNBA',
    link: '/basketball/wnba',
    disabled: false,
    leagues: ['wnba'],
  },
  {
    id: '3',
    sport: 'golf',
    name: 'GOLF',
    link: '/golf/all',
    disabled: false,
    leagues: ['all'],
  },
  {
    id: '69',
    sport: 'tennis',
    name: 'TENNIS',
    link: '/tennis/atp',
    disabled: false,
    leagues: ['atp', 'wta'],
  },
  {
    id: '6962943',
    sport: 'football',
    name: 'FOOTBALL',
    // The name-based icon lookup would hit football.svg, a 19x19 asset that
    // renders undersized next to the other 38x38 nav icons — pin the slug.
    iconSlug: 'nfl',
    link: '/football/nfl-preseason',
    disabled: false,
    leagues: ['nfl-preseason', 'cfl', 'ufl', 'nfl', 'ncaaf', 'ncaaf-extras'],
  },
  {
    id: 'all-props',
    sport: 'props',
    name: 'PROPS',
    link: '/all-props',
    disabled: false,
  },
  {
    id: '4434',
    sport: 'politics',
    name: 'Politics',
    link: '/politics/politics',
    disabled: false,
    leagues: ['politics'],
  },
  {
    id: '566',
    sport: 'horses',
    name: 'Horses',
    link: '/horses/winner',
    disabled: false,
    leagues: ['winner'],
  },
  {
    id: '57',
    sport: 'custom',
    name: 'Custom',
    link: '/custom/custom',
    disabled: false,
    iconFrom: 'fontawesome',
    icon: 'plus-circle',
  },
];

export const allPropsRouteNames = [
  'AllProps',
  'AllPropsExchange',
  'AllPropsSportsbook',
];

export const adjustLinksForExchange = (sport) => ({
  ...sport,
  link: `/exchange${sport.link}`,
});

export function filterAvailableSports(
  sports,
  sportsAvailable,
  { excludeCustom = false } = {},
) {
  if (!sportsAvailable) return [];

  return sports.filter((sport) => {
    if (excludeCustom && sport.sport === 'custom') return false;
    return sport.id === 'all-props' || sportsAvailable[sport.sport];
  });
}
